// src/__internal__/core/useCoreActions.ts
import { useContext } from "react";
import { CoreActionsContext } from "./CoreProvider.mjs";
var useCoreActions = () => useContext(CoreActionsContext);
export {
  useCoreActions
};
